



















import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseLink from '@shared/components/@atoms/BaseLink/BaseLink.vue';
import BannerAspectRatio from '@shared/components/AspectRatio/BannerAspectRatio/BannerAspectRatio.vue';
import { BannerAspectRatioSize } from '@shared/types/BannerAspectRatio';
import { Image } from '@shared/types/Image';
import responsiveMixin from '@shared/ui/utilities/mixins/responsiveMixin';

export default defineComponent({
  name: 'BaseBanner',
  components: {
    BaseButton,
    BaseLink,
    BannerAspectRatio,
  },
  mixins: [responsiveMixin],
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: null,
    },
    bannerImage: {
      type: Object as PropType<Image>,
      required: true,
    },
    bannerImageMobile: {
      type: Object as PropType<Image>,
      default: null,
    },
    size: {
      type: String as PropType<BannerAspectRatioSize>,
      default: 'medium',
    },
  },
  setup(props) {
    const wrapper = computed(() => {
      return props.link ? 'BaseLink' : 'div';
    });

    return { wrapper };
  },
});
